export const TransactionsSortOptions = [
    'BOOKING_DATE',
    'BOOKING_DATE_ASC',
    'BOOKING_DATE_DESC',
    'EXECUTION_DATE',
    'EXECUTION_DATE_ASC',
    'EXECUTION_DATE_DESC',
    'MAIN_DATE',
    'MAIN_DATE_ASC',
    'MAIN_DATE_DESC',
    'INPUT_DATE',
    'INPUT_DATE_ASC',
    'INPUT_DATE_DESC',
    'AMOUNT',
    'AMOUNT_ASC',
    'AMOUNT_DESC',
    'VARIABLE_SYMBOL',
    'VARIABLE_SYMBOL_ASC',
    'VARIABLE_SYMBOL_DESC',
] as const;

export type TransactionsSort = (typeof TransactionsSortOptions)[number];

export type TransactionsGroupingField =
    | 'transactionDateTime'
    | 'bookingDate'
    | 'inputDate'
    | 'valuationDate';
